import DashboardService from "features/dashboard/services/DashboardService";
import IDashboardService from "features/dashboard/services/IDashboardService";
import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";

export const dashboardModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<IDashboardService>(IocTypes.DashboardService).to(DashboardService);
});